/**
 * getBillingDataApi.js
 *
 * Provides an API call to fetch billing data for one or more subscriptions.
 * Used in self-care to display billing information to users.
 *
 * Exports:
 * - getBillingData: Fetches billing data for specified subscription IDs.
 */

import { postWithData } from "../shared/apiPatterns";

/**
 * Fetches billing data for specified subscription IDs.
 *
 * @param {Object} options - The options object.
 * @param {Array<string>} options.ids - Array of subscription IDs to fetch billing data for.
 * @returns {Promise<Object|null>} The API response JSON, or null on error.
 */
export const getBillingData = ({ ids }) =>
  postWithData("/get-billing-data", {
    id: ids.length === 1 ? ids[0] : ids,
  });
